import { DashboardState } from '@/store/modules/dashboard/dashboardState';

const state: DashboardState = {
    vehicles: [],
    notificationTypes: [],
    notificationTypesFeedback: [],
};

export default state;
